import { Record } from 'immutable'

export const Attachment = Record({
  conversationId: undefined,
  createdAt: undefined,
  fileName: undefined,
  hash: undefined,
  height: undefined,
  id: undefined,
  mimeType: undefined,
  orgId: undefined,
  publicId: undefined,
  publicPreviewUrl: undefined,
  publicUrl: undefined,
  size_: undefined,
  width: undefined,
})



// WEBPACK FOOTER //
// ./src/scripts/app/modules/message/attachment/models.js